<template>
  <div class="modal-overlay" @click.self="closeModal">
    <div class="modal-content" :class="{ 'modal-content--wide': !!details }">
      <h2>{{ message }}</h2>
      <p v-if="details" class="modal-details">{{ details }}</p>
      <button @click="confirm" class="p-button p-confirm-popup-accept">
        Confirmar
      </button>
      <button @click="closeModal" class="p-button p-confirm-popup-reject">
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleConfirmComponent",
  props: {
    message: {
      type: String,
      required: true,
    },
    // Texto informativo opcional (ex.: o porquê da confirmação), mostrado
    // abaixo da pergunta principal em corpo normal — a pergunta em si
    // (`message`) fica curta e continua a ler-se como um título.
    details: {
      type: String,
      default: "",
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
      this.closeModal();
    },
    closeModal() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  /* background: #626288; */
  background: var(--fundoApp);
  color: var(--text);
  border: 0 none;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  max-width: 300px; /* Set maximum width */
  width: 90%; /* Use percentage for responsiveness */
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

/* Quando há `details`, o conteúdo tende a ser mais informativo/longo —
   um pouco mais largo lê-se melhor do que apertado em 300px. */
.modal-content--wide {
  max-width: 420px;
}

.modal-content h2 {
  font-size: 1.2rem;
  word-wrap: break-word; /* Ensure text wraps */
  white-space: normal; /* Allow text to wrap */
  margin-bottom: 15px;
}

.modal-details {
  font-size: 0.85rem;
  font-weight: normal;
  opacity: 0.85;
  word-wrap: break-word;
  white-space: normal;
  text-align: left;
  margin: -8px 0 15px;
}

.modal-content button {
  margin: 10px;
  font-size: 14px;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
}

.p-confirm-popup-reject {
  background-color: rgba(255, 0, 0, 0.792);
  color: white;
}

.p-confirm-popup-accept {
  background-color: rgb(255, 155, 5);
  color: white;
}
</style>
